module.exports = __webpack_public_path__ + "img/finance.2f267c4e.svg";